// import {Headers, RequestOptions} from '@angular/http';

export class AppConfig {
    public static API_ENDPOINT = 'https://otacon.us/apis/';
    // public static API_ENDPOINT = "https://livefreenow.us:5003/";
    // public static API_ENDPOINT = "https://imrservice.us:5003/";
    // public static API_ENDPOINT = "http://192.168.100.206:5007/apis/";
    public static emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
    // public static domain = 'https://iponym.ai/';
    // public static domain = 'http://192.168.10.254:4200/';

}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_utilities/app-config.ts